import { getDockedStyles } from '../dockedLayer'
import { FixedItemLayout, PopupAlignment, SingleLayoutData } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import { DockedCompLayout } from '../types'
import { marginsToCss } from './responsive/layoutToCss'

const convertPopupAlignmentToDockedData = (popupAlignment: PopupAlignment) => {
	const horizontalAlignmentToDockKey = {
		left: 'left',
		right: 'right',
		center: 'hCenter',
	}
	const verticalAlignmentToDockKey = {
		top: 'top',
		bottom: 'bottom',
		center: 'vCenter',
	}

	if (popupAlignment.alignmentType === 'nineGrid') {
		return {
			[horizontalAlignmentToDockKey[popupAlignment.horizontalAlignment]]: { px: popupAlignment.horizontalOffset },
			[verticalAlignmentToDockKey[popupAlignment.verticalAlignment]]: { px: popupAlignment.verticalOffset },
		}
	}

	if (popupAlignment.alignmentType === 'fullHeight') {
		return {
			top: { px: 0 },
			bottom: { px: 0 },
			[horizontalAlignmentToDockKey[popupAlignment.horizontalAlignment]]: { px: 0 },
		}
	}

	if (popupAlignment.alignmentType === 'fullWidth') {
		return {
			left: { px: 0 },
			right: { px: 0 },
			[verticalAlignmentToDockKey[popupAlignment.verticalAlignment]]: { px: 0 },
		}
	}
	return {}
}

const getDockedCssForCompLayouts = (compLayout: DockedCompLayout, popupAlignment: PopupAlignment) => {
	const isIE = false // TODO: Real isIE
	const growToContent = true
	const dockedPopup = _.defaults({ docked: convertPopupAlignmentToDockedData(popupAlignment) }, compLayout)
	const dockedStyles = getDockedStyles([dockedPopup], isIE, growToContent)
	return _.mapKeys(dockedStyles[compLayout.id], (val, key) => _.kebabCase(key))
}

const isFullWidth = (itemLayout: FixedItemLayout): boolean => {
	return !!(itemLayout.margins?.left && itemLayout.margins?.right)
}

const isFullHeight = (itemLayout: FixedItemLayout): boolean => {
	return !!(itemLayout.margins?.top && itemLayout.margins?.bottom)
}

const getDockedCss = (compSingleLayout?: SingleLayoutData) => {
	const itemLayout = compSingleLayout?.itemLayout

	if (itemLayout?.type !== 'FixedItemLayout') {
		return {}
	}

	const fullWidth = isFullWidth(itemLayout)
	const fullHeight = isFullHeight(itemLayout)

	return {
		position: 'relative',
		'grid-area': [1, 1, 2, 2].join(' / '),
		'pointer-events': 'auto',
		...(!fullHeight && {
			'align-self': itemLayout.alignSelf,
		}),
		...(!fullWidth && {
			'justify-self': itemLayout.justifySelf,
		}),
		...(fullWidth && {
			width: '100%',
		}),
		...(fullHeight && {
			height: '100%',
		}),
		...marginsToCss(itemLayout.margins),
	}
}

export { getDockedCssForCompLayouts, getDockedCss }
